<template>
  <div class="column is-10 container">
    <!-- <h1 class="title is-1 has-text-centered">{{ $t("Partners.Title") }}</h1> -->
    <vue-agile :nav-buttons="false" :infinite="false">
      <div
        class="slide has-text-centered"
        v-for="(slide, idx_i) in slides"
        :key="idx_i"
      >
        <div class="image" :class="'image-' + (idx_i + 1)">
          <img :src="slide.img" width="302" height="604" />
          <template v-for="(item, idx) in slide.text">
            <div
              class="arrow"
              :class="'arrow-' + (idx + 1) + ' ' + items[idx_i + 1][idx]"
              :key="'arrow-' + idx"
            ></div>
            <div class="text" :class="'text-' + (idx + 1)" :key="'text-' + idx">
              <h4>{{ item.title }}</h4>
              {{ item.description }}
            </div>
          </template>
        </div>
      </div>
    </vue-agile>
  </div>
</template>

<script>
import { VueAgile } from 'vue-agile'

export default {
  name: 'starApp',
  data () {
    return {
      items: {
        1: ['topright', 'bottomright', 'bottomright', 'topleft'],
        2: ['topright', 'bottomright', 'bottomright', 'bottomleft'],
        3: ['bottomleft', 'bottomright', 'bottomright', 'bottomleft']
      },
      icons: {}
    }
  },
  props: {
    slides: {
      type: Array,
      default: () => {}
    }
  },
  components: {
    VueAgile
  },
  computed: {},
  methods: {}
}
</script>

<style lang="scss" scoped>
$dotHalf: 9px;
$imageWidth: 302px;
$arrowWidth: 210px;

.container{
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.slide {
  user-select: none;
  > .image {
    width: $imageWidth;
    margin: 0 auto;
    position: relative;

    img {
      width: $imageWidth;
      height: ($imageWidth * 2);
    }
    .arrow {
      position: absolute;
      width: $arrowWidth;
      border: 2px solid transparent;
      &:before,
      &:after {
        content: " ";
        width: ($dotHalf * 2) - 1px;
        height: ($dotHalf * 2) - 1px;
        background-color: $green;
        position: absolute;
        border-radius: ($dotHalf * 2);
      }
      &.topleft {
        border-top-color: $green;
        border-left-color: $green;
        &:before {
          bottom: -$dotHalf;
          left: -$dotHalf;
        }
        &:after {
          top: -$dotHalf;
          right: -$dotHalf;
        }
      }
      &.topright {
        border-top-color: $green;
        border-right-color: $green;
        &:before {
          bottom: -$dotHalf;
          right: -$dotHalf;
        }
        &:after {
          top: -$dotHalf;
          left: -$dotHalf;
        }
      }
      &.bottomleft {
        border-bottom-color: $green;
        border-left-color: $green;
        &:before {
          top: -$dotHalf;
          left: -$dotHalf;
        }
        &:after {
          bottom: -$dotHalf;
          right: -$dotHalf;
        }
      }
      &.bottomright {
        border-bottom-color: $green;
        border-right-color: $green;
        &:before {
          top: -$dotHalf;
          right: -$dotHalf;
        }
        &:after {
          bottom: -$dotHalf;
          left: -$dotHalf;
        }
      }
      &-1,
      &-2 {
        left: -($imageWidth / 2);
      }
      &-3,
      &-4 {
        right: -($imageWidth / 2);
      }
    }
    .text {
      position: absolute;
      text-align: right;
      width: ($imageWidth / 2);
      height: 200px;
      font-size: 16px;
      h4 {
        font-weight: 600;
        font-size: 18px;
        margin: 5px 0;
      }
      &-1,
      &-2 {
        left: -($arrowWidth + ($imageWidth / 2));
        text-align: right;
      }
      &-3,
      &-4 {
        right: -($arrowWidth + ($imageWidth / 2));
        text-align: left;
      }
      &-1,
      &-3 {
        top: 50px;
      }
      &-2,
      &-4 {
        top: 400px;
      }
    }
    &-1 {
      .arrow {
        &-1 {
          height: 20px;
          top: 112px;
        }

        &-2 {
          height: 40px;
          top: 380px;
        }

        &-3 {
          height: 70px;
          top: 87px;
        }

        &-4 {
          height: 90px;
          top: 430px;
        }
      }
    }
    &-2 {
      .arrow {
        &-1 {
          height: 90px;
          top: 112px;
        }

        &-2 {
          height: 40px;
          top: 380px;
        }

        &-3 {
          height: 40px;
          top: 87px;
        }

        &-4 {
          height: 40px;
          top: 430px;
        }
      }
    }
    &-3 {
      .arrow {
        &-1 {
          height: 60px;
          top: 87px;
        }

        &-2 {
          height: 120px;
          top: 300px;
        }

        &-3 {
          height: 130px;
          top: 97px;
        }

        &-4 {
          height: 40px;
          top: 400px;
        }
      }
    }
    @media screen and (max-width: $bp-widescreen - 1px) {
      .arrow {
        width: 150px;
        &-1,
        &-2 {
          left: -(($imageWidth / 2) - 30);
        }
        &-3,
        &-4 {
          right: -(($imageWidth / 2) - 30);
        }
      }
      .text {
        font-size: 0.8em;
        &-1,
        &-2 {
          left: -(($arrowWidth + ($imageWidth / 2)) - 50);
        }
        &-3,
        &-4 {
          right: -(($arrowWidth + ($imageWidth / 2)) - 50);
        }
      }
    }

    @media screen and (max-width: $bp-desktop - 1px) {
      .arrow {
        display: none;
      }
      .text {
        &-1,
        &-2 {
          left: -(($arrowWidth + ($imageWidth / 2)) - 160);
        }
        &-3,
        &-4 {
          right: -(($arrowWidth + ($imageWidth / 2)) - 160);
        }
      }
    }
    @media screen and (max-width: $bp-tablet - 1px) {
      .arrow {

      }
      .text {
        display: none;
      }
    }
  }
}
/deep/.agile {
  .agile__actions {
    justify-content: center;
    margin-top: 2rem;
    .agile__dots {
      list-style: none;
      margin-left: 0;
      margin-top: 0;
      .agile__dot {
        > button {
          border: none;
          background-color: $grey-lighter;
          width: 20px;
          height: 20px;
          border-radius: 50%;
        }
        + .agile__dot {
          margin-left: 5px;
          margin-top: 0px;
        }
        &.agile__dot--current {
          > button {
            background-color: $primary;
          }
        }
      }
    }
  }
}
</style>
